if (!customElements.get('custom-dropdown')) {
  class CustomDropdown extends HTMLElement {
    constructor() {
      super();

      this.dropdown = this.querySelector('.dropdown');
      this.dropdown.addEventListener('click', this.openDropdown.bind(this));
    }

    openDropdown() {
      this.dropdown.classList.toggle('dropdown--active');
    }
  }

  customElements.define('custom-dropdown', CustomDropdown);
}